// Action types
export const REQUEST = 'MODEL_DELETE_REQUEST';
export const SUCCESS = 'MODEL_DELETE_SUCCESS';
export const FAILURE = 'MODEL_DELETE_FAILURE';
export const CLEAR = 'MODEL_DELETE_CLEAR';

// Action creators
export const deleteModelRequest = (payload) => ({
  type: REQUEST,
  payload
});

export const deleteModelSuccess = (payload) => ({
  type: SUCCESS,
  payload
});

export const deleteModelFailure = (payload) => ({
  type: FAILURE,
  payload
});

export const deleteModelClear = () => ({
  type: CLEAR
}); 